import { useAuth } from '../../contexts/AuthContext';

const OnboardingStep5Complete = ({ onComplete, isLoading }) => {
  const { user, preferences } = useAuth();

  const handleGetStarted = () => {
    onComplete();
  };

  return (
    <div className="onboarding-step complete-step">
      <div className="complete-content">
        <div className="complete-icon">🎉</div>
        
        <h3>Welcome to readTheWord!</h3>
        
        <p>
          Congratulations, {user?.name}! Your account is set up and you're ready to start 
          tracking your Bible reading journey.
        </p>

        <div className="setup-summary">
          <h4>Your Setup Summary:</h4>
          <div className="summary-items">
            <div className="summary-item">
              <span className="summary-icon">📖</span>
              <span className="summary-text">
                Bible Translation: <strong>{preferences?.bibleTranslation || 'ESV'}</strong>
              </span>
            </div>
            
            <div className="summary-item">
              <span className="summary-icon">🎯</span>
              <span className="summary-text">
                App Mode: <strong>
                  {preferences?.appUsageMode === 'tracking' && 'Tracking Only'}
                  {preferences?.appUsageMode === 'reading' && 'Reading in App'}
                  {preferences?.appUsageMode === 'both' && 'Both Tracking & Reading'}
                </strong>
              </span>
            </div>
            
            <div className="summary-item">
              <span className="summary-icon">🏆</span>
              <span className="summary-text">
                Competitive Mode: <strong>{preferences?.competitiveMode ? 'Enabled' : 'Disabled'}</strong>
              </span>
            </div>
          </div>
        </div>

        <div className="next-steps">
          <h4>What's Next?</h4>
          <ul className="next-steps-list">
            <li>📊 Log today's reading on Home</li>
            <li>👨‍👩‍👧‍👦 Create or join a family group</li>
            <li>👥 Add family members as readers</li>
            <li>📈 Track your progress and view statistics</li>
            <li>⚙️ Customize your settings anytime</li>
          </ul>
        </div>

        <div className="step-actions">
          <button 
            className="btn-primary large"
            onClick={handleGetStarted}
            disabled={isLoading}
          >
            {isLoading ? 'Loading...' : 'Start Reading Journey! 🚀'}
          </button>
        </div>
      </div>

      <style jsx>{`
        .complete-step {
          text-align: center;
        }

        .complete-content {
          padding: 20px 0;
        }

        .complete-icon {
          font-size: 64px;
          margin-bottom: 24px;
        }

        .complete-step h3 {
          margin: 0 0 16px 0;
          color: var(--color-text);
          font-size: 24px;
          font-weight: 600;
        }

        .complete-step p {
          margin-bottom: 32px;
          font-size: 16px;
        }

        .setup-summary {
          background: var(--color-background);
          border: 1px solid var(--color-border);
          border-radius: 12px;
          padding: 24px;
          margin: 24px 0;
          text-align: left;
        }

        .setup-summary h4 {
          margin: 0 0 16px 0;
          color: var(--color-text);
          font-size: 16px;
          text-align: center;
        }

        .summary-items {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .summary-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 8px 0;
        }

        .summary-icon {
          font-size: 18px;
          flex-shrink: 0;
        }

        .summary-text {
          color: var(--color-text-secondary);
          font-size: 14px;
        }

        .summary-text strong {
          color: var(--color-text);
        }

        .next-steps {
          text-align: left;
          max-width: 400px;
          margin: 32px auto;
        }

        .next-steps h4 {
          margin: 0 0 16px 0;
          color: var(--color-text);
          font-size: 16px;
          text-align: center;
        }

        .next-steps-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .next-steps-list li {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 8px 0;
          color: var(--color-text-secondary);
          font-size: 14px;
        }

        .btn-primary.large {
          font-size: 18px;
          padding: 16px 32px;
          min-width: 250px;
        }

        @media (max-width: 768px) {
          .setup-summary {
            text-align: center;
          }

          .summary-items {
            align-items: center;
          }

          .next-steps {
            max-width: 100%;
          }

          .btn-primary.large {
            width: 100%;
            max-width: 300px;
          }
        }
      `}</style>
    </div>
  );
};

export default OnboardingStep5Complete;
